<template>
  <div>
    <div class="">
      <div
        id="container"
        class="pt-3 pb-0 pl-5 pr-0 container-bg mem-admin-wrap dash-pdd"
      >
        <div class="row">
          <div class="col-6">
            <h3 class="mb-4 text-uppercase">Alle Leden</h3>
          </div>
          <div class="pr-4 text-right col-6">
            <router-link to="/profile/create" class="mr-2 btn btn-primary">
              <i class="mr-2 fa fa-plus"></i>
              Nieuw lid toevoegen
            </router-link>
            <button @click="exportFilter()" class="text-white btn btn-dark">
              <span v-if="excel_loading">Downloading....</span>
              <span v-else
                >Export
                <span v-if="Object.keys(filters).length != 0">selectie</span>
              </span>
            </button>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-hover" id="table_id">
            <thead>
              <tr>
                <th></th>
                <th
                  v-for="(key, index) in attributes"
                  :key="'th_' + key + index"
                >
                  {{ key }}
                </th>
              </tr>
              <tr>
                <th></th>
                <th
                  v-for="(key, index) in attributes"
                  :key="'th_' + key + index"
                  style="min-width: 130px"
                >
                  <select
                    @change="filterMembers()"
                    v-model="filters[index]"
                    class="form-control"
                    :placeholder="key"
                    v-if="index == 'gender'"
                  >
                    <option value=""></option>
                    <option value="-1">Vrouw</option>
                    <option value="1">Man</option>
                  </select>

                  <select
                    @change="filterMembers()"
                    v-model="filters[index]"
                    class="form-control"
                    :placeholder="key"
                    v-else-if="index == 'isActive'"
                    style="min-width: 100px"
                  >
                    <option value=""></option>
                    <option value="1">Actief</option>
                    <option value="0">Inactief</option>
                  </select>
                  <input
                    @keyup="filterMembers()"
                    v-model="filters[index]"
                    type="text"
                    class="form-control"
                    placeholder="yyyy-mm-dd"
                    v-else-if="
                      ['date_of_birth', 'member_since', 'member_end'].includes(
                        index
                      )
                    "
                  />
                  <input
                    @keyup="filterMembers()"
                    v-model="filters[index]"
                    type="text"
                    class="form-control"
                    :placeholder="key"
                    v-else
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in users" :key="user.id">
                <td>
                  <a
                    :href="'/profile/' + user.id + '/view'"
                    style="margin-right: 10px"
                    class="text-white btn btn-dark"
                    ><i class="fa fa-eye"></i
                  ></a>
                </td>
                <td
                  v-for="(key, index) in attributes"
                  :key="'td_' + user.id + key + index"
                >
                  {{ displayUserProperty(user[index], index) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "datatables.net-bs4";
import { mapState } from "vuex";
export default {
  name: "members",
  components: {
    //VdtnetTable
  },
  computed: mapState({
    user: (state) => state.auth.user,
  }),
  data() {
    return {
      users: [],
      attributes: {
        isActive: "Actief",
        salutation: "Aanhef",
        firstname: "Voornaam",
        lastname: "Achternaam",
        address: "Adres",
        // 'address2' : 'Adresregel 2',
        zipcode: "Postcode",
        city: "Plaats",
        country: "Land",
        phone: "Telefoonnummer",
        mobile: "Mobiel",
        website: "Website",
        date_of_birth: "Geboortedatum",
        member_since: "Lid sinds",
        member_end: "Lid tot",
        // 'about_me' : 'Over mij',
        email: "Email",
        gender: "Geslacht",
        display_name: "Weergavenaam",
      },
      options: {
        ajax: {
          url: "/users/all",
          dataSrc: (json) => {
            return json;
          },
        },
        buttons: ["copy", "csv", "print"],
        /*eslint-disable */
        dom:
          "Btr<'row vdtnet-footer'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'pl>>",
        /*eslint-enable */
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        fixedHeader: true,
        saveState: true /*,
        select: {
          style: 'multi'
        }*/,
      },
      fields: {
        id: { label: "ID", sortable: true },
        actions: {
          isLocal: true,
          label: "Actions",
          defaultContent:
            '<a href="javascript:void(0);" data-action="edit" class="btn btn-primary btn-sm"><i class="mdi mdi-square-edit-outline"></i> Edit</a>' +
            '<span data-action="delete" class="btn btn-danger btn-sm"><i class="mdi mdi-delete"></i> Delete</span>',
        },
        name: {
          label: "Name",
          sortable: true,
          searchable: true,
          defaultOrder: "desc",
        },
        username: { label: "Username", sortable: false, searchable: true },
        email: { label: "Email" },
        address1: {
          label: "Address1",
          data: "address",
          template: "{{ data.street }}, {{ data.suite }}",
        },
        address2: {
          label: "Address2",
          data: "address",
        },
        phone: { label: "Phone" },
        website: {
          label: "Website",
          render: (data) => {
            return `https://${data}`;
          },
        },
      },
      quickSearch: "",
      details: {},
      filters: {},
      excel_loading: false,
    };
  },
  methods: {
    exportFilter() {
      this.excel_loading = true;
      console.log("to be sent", this.filters);

      axios
        .post(
          process.env.VUE_APP_API_BASE_URL +
            "/api/v1/committees/members/export-filter",
          this.filters,
          {
            responseType: "blob",
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((data) => {
          this.excel_loading = false;

          const type = data.headers["content-type"];
          const blob = new File([data.data], { type: type });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = new Date().toDateString() + ".xlsx";
          link.click();
        })
        .catch((error) => {
          console.log(error);
          this.excel_loading = false;
        });
    },
    filterMembers() {
      this.$store
        .dispatch("post", {
          details: this.filters,
          endpoint: "api/v1/committees/members/filter",
        })
        .then((data) => {
          this.users = data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    doLoadTable(cb) {
      console.log(cb);
    },
    displayUserProperty(property, index) {
      if (index == "gender") {
        if (property == 1) {
          return "Man";
        } else {
          return "Vrouw";
        }
      } else if (index == "isActive") {
        if (property) {
          return "Actief";
        } else {
          return "Inactief";
        }
      } else {
        return property;
      }
    }
  },
  mounted() {
    var container = window.$("#container");
    var tableBody = window.$("table tbody");
    var top = container.offset().top + 150;
    var window_height = window.screen.height;
    var height = window_height - top;
    container.css("height", height);
    window
      .$("table tbody")
      .css("height", height - (tableBody.offset().top - top));
  },
  created() {
    console.log(this.$store.state.auth.user);
    console.log(this.userHasRoles(["Super-Admin"]));

    this.$store
      .dispatch("get", "api/v1/users/all")
      .then((data) => {
        this.users = data.data.data;

        window.$(document).ready(function() {
          window
            .$(".table-responsive")
            .doubleScroll({ resetOnWindowResize: true });
        });
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>

<style scoped>
.table-responsive {
  max-height: 28em;
}
/* th{
    padding-top: 0px;
}
#container{
    overflow: hidden;
}
body{
    overflow: hidden;
}
table {
    overflow: auto;
}

thead th {
    position: sticky;
    top: 0;
    background:#cee4f7;
}
thead, tbody { display: block; }

tbody {
    overflow-y: auto;
    overflow-x: hidden;
} */
</style>
